// extracted by mini-css-extract-plugin
module.exports = {"buttonPlaceholderWrap":"ButtonPlaceholder_buttonPlaceholderWrap__1sKaz","buttonPlaceholder":"ButtonPlaceholder_buttonPlaceholder__3qYJ_"};